.form {
  width: 100%;
  max-width: 34rem;
}

.row {
  display: flex;
  align-items: stretch;
  gap: 0.75rem;
}

.field {
  flex: 1;
  min-width: 0;
}

.input {
  width: 100%;
  height: 3.25rem;
  padding-inline: 1rem;
  border-radius: var(--radius-md);
  background: var(--color-card);
  font-size: 1rem;
}

.honeypot {
  position: absolute;
  inset-inline-start: -10000px;
}

.submit {
  flex-shrink: 0;
  min-height: 3.25rem;
}

.note,
.error {
  margin-top: 0.75rem;
}

.success {
  display: flex;
  align-items: center;
  gap: 0.875rem;
}

.successIcon {
  width: 2.75rem;
  height: 2.75rem;
  flex-shrink: 0;
  display: grid;
  place-items: center;
  border-radius: var(--radius-lg);
  background: var(--color-primary-soft);
  color: var(--color-primary);
}

@media (max-width: 640px) {
  .row {
    flex-direction: column;
  }

  .submit {
    width: 100%;
  }
}
